import { Typography } from '@mui/material';
import React from 'react';

// Define the type for the confirm function's argument
interface ConfirmOptions {
  title: string;
  label: string;
  content: React.ReactNode;
}

export const confirmChangeType = async ({ confirm, intl }) => {
  const options: ConfirmOptions = {
    title: intl.formatMessage({ id: 'POST_FORM.FORM_BUILDER.TYPE_SELECT_WARNING.TITLE' }),
    label: intl.formatMessage({ id: 'POST_FORM.FORM_BUILDER.TYPE_SELECT_WARNING.TITLE' }),
    content: (
      <div>
        <Typography variant="body2" gutterBottom>
          {intl.formatMessage({ id: 'POST_FORM.FORM_BUILDER.TYPE_SELECT_WARNING.DESCRIPTION_1' })}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {intl.formatMessage({ id: 'POST_FORM.FORM_BUILDER.TYPE_SELECT_WARNING.DESCRIPTION_2' })}
        </Typography>
        <Typography variant="body2" gutterBottom>
          {intl.formatMessage({ id: 'POST_FORM.FORM_BUILDER.TYPE_SELECT_WARNING.DESCRIPTION_3' })}
        </Typography>
      </div>
    ),
  };

  return confirm(options);
};
